import { RelatedArticles2ColumnWrapper, ArrowRightIcon } from './style';
import { H3, H5, P, Column, Row } from '../../styleguide-remapped/styleguide-remapped';
import arrowRightSvg from '../../../assets/logos/arrow-right.svg';
import { uid } from 'react-uid';
import Breadcrumbs from '../../custom/breadcrumbs';
import Link from 'next/link';

const RelatedArticles2Columns = ({ block, documentData, pageType, relatedCategories, relatedTopics, categoryArticles }) => {
  const dynamicArticles = getImpressionBasedArticles(relatedTopics, documentData, categoryArticles);
  const col1Articles = block.articlesCol1?.articles?.data || [];
  const col2Articles = block.articlesCol2?.articles?.data || [];
  const allStaticArticles = [...col1Articles, ...col2Articles];

  const filteredDynamicArticles = dynamicArticles.filter((dynamic) => !allStaticArticles.some((staticArticle) => staticArticle.id === dynamic.id));

  let [filledCol1Articles, updatedDynamicArticles] = fillColumnWithDynamicArticles(col1Articles, filteredDynamicArticles);
  let [filledCol2Articles, _] = fillColumnWithDynamicArticles(col2Articles, updatedDynamicArticles);

  return (
    <RelatedArticles2ColumnWrapper className={pageType}>
      <H3 as="h2">{block.headline}</H3>
      <Row role={filledCol1Articles.length + filledCol2Articles.length > 0 ? 'list' : undefined}>
        {articleColumn(filledCol1Articles, [...relatedCategories, documentData], relatedTopics)}
        {articleColumn(filledCol2Articles, [...relatedCategories, documentData], relatedTopics)}
      </Row>
    </RelatedArticles2ColumnWrapper>
  );
};

const getImpressionBasedArticles = (relatedTopics, category, categoryArticles = []) => {
  if (categoryArticles?.length > 0) {
    return categoryArticles;
  }

  let articlesWithImpressions = [];
  relatedTopics.forEach((topic) => {
    if (topic.attributes?.category?.data?.id === category.id && Array.isArray(topic.attributes?.articles)) {
      topic.attributes.articles.forEach((section) => {
        if (section.__component === 'block.section' && Array.isArray(section.articles?.data)) {
          articlesWithImpressions.push(...section.articles.data);
        }
      });
    }
  });

  return [...new Map(articlesWithImpressions.map((item) => [item['id'], item])).values()].sort((a, b) => (b.attributes?.pageImpressionCount || 0) - (a.attributes?.pageImpressionCount || 0));
};

const fillColumnWithDynamicArticles = (columnArticles, dynamicArticles, desiredLength = 3) => {
  let remainingArticles = desiredLength - columnArticles.length;
  if (remainingArticles <= 0) return [columnArticles, dynamicArticles];

  let extraDynamicArticles = dynamicArticles.slice(0, remainingArticles);
  columnArticles.push(...extraDynamicArticles);

  return [columnArticles, dynamicArticles.slice(remainingArticles)];
};

const articleColumn = (articles, categories, topics) => (
  <Column all={12} xs={12} s={12} m={6} px={0} mx={0} className="column" role="presentation">
    {articles.map((article) => (
      <div role="listitem" key={uid(article)}>
        <article className="container">
          <Link href={'/artikel/' + article.attributes.slug}>
            <div className="article-container">
              <Row className="article-header">
                <H5 as="h3" className="tile-title">{article.attributes.title}</H5>
                <ArrowRightIcon src={arrowRightSvg} />
              </Row>
              <P className="description"> {article.attributes.description} </P>
            </div>
          </Link>
          <Breadcrumbs categories={categories} topics={topics} articles={[article]} breadcrumbKey={`${uid(article)}-b`} />
        </article>
      </div>
    ))}
  </Column>
);

export default RelatedArticles2Columns;
